import Users from '@/pages/usersAdmin/UsersAdmin.page';
import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth/users')({
  component: () => <UsersLayout />,
});

const UsersLayout = () => {
  return (
    <>
      <Users />
      <Outlet />
    </>
  );
};
